export default __webpack_public_path__ + "locales/ru/Files.json?hash=4b0eb0b5162654c57fed6f383f1a7b97";